/* eslint-disable @typescript-eslint/no-explicit-any */
import { useHeaderContext } from '@/sinister/header/contexts/HeaderContext'
import styled from 'styled-components'
import TextAtomic from '../atomic/Text'

const StyledText = styled(TextAtomic)`
  font-size: var(--app-header-fontsize-s1, --typography-size-s1);
  overflow: hidden;
  max-width: 70px;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: var(${({ color }: { color: string }) => color}, var(--color-white));
`

const TextLogic = ({ Wrapper, children }: { Wrapper: any; children: any }) => {
  const { colorHeader: color } = useHeaderContext()
  return <Wrapper color={color}>{children}</Wrapper>
}

const Text = (props: any) => <TextLogic Wrapper={StyledText} {...props} />

export default Text
